<template>
  <div class="view-container">
    <div class="compose-header">
      <h3><i class="fas fa-pen"></i> 写邮件 - 外邮</h3>
      <span class="hint">使用配置的 SMTP 服务器发送外部邮件</span>
    </div>
    <div class="compose-form">
      <div class="form-row">
        <div class="form-group"><label>发件人</label><input v-model="from" class="form-control" placeholder="user@company.com" disabled></div>
      </div>
      <div class="form-row">
        <div class="form-group"><label>收件人 *</label><div class="recipient-area"><div v-for="(r, idx) in toList" :key="idx" class="recipient-tag"><span>{{ r }}</span><button @click="removeTo(idx)" class="rec-remove"><i class="fas fa-times"></i></button></div><input v-model="toInput" @keyup.enter="addTo" @keyup.tab="addTo" class="inline-input" placeholder="输入邮箱地址，回车添加..."></div></div>
        </div>
        <div class="form-row">
          <div class="form-group"><label>抄送</label><div class="recipient-area"><div v-for="(r, idx) in ccList" :key="idx" class="recipient-tag cc"><span>{{ r }}</span><button @click="removeCc(idx)" class="rec-remove"><i class="fas fa-times"></i></button></div><input v-model="ccInput" @keyup.enter="addCc" @keyup.tab="addCc" class="inline-input" placeholder="输入邮箱地址，回车添加..."></div></div>
      </div>
      <div class="form-row"><div class="form-group"><label>主题 *</label><input v-model="subject" class="form-control subject-input" placeholder="请输入邮件主题"></div></div>
      <div class="form-row"><div class="form-group"><label>内容</label><textarea v-model="body" class="form-control body-area" placeholder="请输入邮件内容..."></textarea></div></div>
      <div class="form-row"><div class="form-group"><label>附件</label><div class="attach-area"><div v-for="(a, idx) in attachments" :key="idx" class="attach-item"><i class="fas fa-paperclip"></i> {{ a.name }} <button @click="removeAttachment(idx)" class="rec-remove"><i class="fas fa-times"></i></button></div><button @click="addAttachment" class="add-attach-btn"><i class="fas fa-plus"></i> 添加附件</button></div></div></div>
      <div class="form-actions"><button @click="sendMail" class="btn btn-primary"><i class="fas fa-paper-plane"></i> 发送 (SMTP)</button><button @click="saveDraft" class="btn btn-default"><i class="fas fa-save"></i> 存草稿</button><button @click="cancelCompose" class="btn btn-default"><i class="fas fa-times"></i> 取消</button></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const from = ref('user@company.com')
const toList = ref([])
const ccList = ref([])
const toInput = ref('')
const ccInput = ref('')
const subject = ref('')
const body = ref('')
const attachments = ref([])

const addTo = () => { const email = toInput.value.trim(); if (email && !toList.value.includes(email)) toList.value.push(email); toInput.value = '' }
const addCc = () => { const email = ccInput.value.trim(); if (email && !ccList.value.includes(email)) ccList.value.push(email); ccInput.value = '' }
const removeTo = (idx) => toList.value.splice(idx, 1)
const removeCc = (idx) => ccList.value.splice(idx, 1)
const removeAttachment = (idx) => attachments.value.splice(idx, 1)
const addAttachment = () => { attachments.value.push({ name: '附件_' + (attachments.value.length + 1) + '.pdf', size: '512KB' }) }

const sendMail = () => {
  if (toList.value.length === 0) { $message.warning('请添加收件人'); return }
  if (!subject.value.trim()) { $message.warning('请输入主题'); return }
  $message.success('邮件已通过 SMTP 发送！')
  clearForm()
}
const saveDraft = () => { $message.success('已保存至外邮草稿箱'); clearForm() }
const cancelCompose = async () => { if (subject.value || body.value) { if (!await $confirm('确定放弃？')) return } clearForm() }
const clearForm = () => { toList.value = []; ccList.value = []; subject.value = ''; body.value = ''; attachments.value = []; toInput.value = ''; ccInput.value = '' }
</script>

<style scoped>
.view-container { padding: 24px; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); max-height: calc(100vh - 110px); overflow-y: auto; }
.compose-header { margin-bottom: 24px; }
.compose-header h3 { margin: 0 0 4px 0; font-size: 18px; color: #1f2937; display: flex; align-items: center; gap: 8px; }
.compose-header .hint { font-size: 12px; color: #9ca3af; }
.compose-form { max-width: 800px; }
.form-row { margin-bottom: 20px; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; font-size: 13px; color: #374151; font-weight: 500; margin-bottom: 6px; }
.form-group .form-control { width: 100%; padding: 10px 14px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; box-sizing: border-box; }
.form-group .form-control:disabled { background: #f9fafb; color: #9ca3af; }
.subject-input { font-size: 14px !important; }
.body-area { width: 100%; min-height: 280px; padding: 14px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; line-height: 1.6; box-sizing: border-box; resize: vertical; font-family: inherit; }
.body-area:focus { outline: none; border-color: #f59e0b; box-shadow: 0 0 0 3px rgba(245,158,11,0.1); }

.recipient-area { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 6px; min-height: 40px; background: #fafbfc; }
.recipient-tag { display: flex; align-items: center; gap: 4px; background: #fef3c7; border: 1px solid #fde68a; border-radius: 16px; padding: 2px 6px 2px 10px; font-size: 12px; }
.recipient-tag.cc { background: #f3e8ff; border-color: #d8b4fe; }
.rec-remove { background: none; border: none; color: #9ca3af; cursor: pointer; font-size: 10px; padding: 2px; }
.rec-remove:hover { color: #ef4444; }
.inline-input { border: none; outline: none; flex: 1; min-width: 120px; font-size: 12px; padding: 3px; background: transparent; }

.attach-area { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.attach-item { display: flex; align-items: center; gap: 6px; padding: 6px 12px; background: #f3f4f6; border-radius: 4px; font-size: 12px; color: #374151; }
.add-attach-btn { border: 1px dashed #d1d5db; border-radius: 4px; background: none; padding: 6px 12px; font-size: 12px; color: #6b7280; cursor: pointer; display: flex; align-items: center; gap: 4px; }
.add-attach-btn:hover { border-color: #f59e0b; color: #f59e0b; }

.form-actions { display: flex; gap: 10px; padding-top: 16px; border-top: 1px solid #f3f4f6; }
.btn { padding: 8px 20px; border: 1px solid transparent; border-radius: 6px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.2s; }
.btn-primary { background: #f59e0b; color: #fff; border-color: #f59e0b; }
.btn-primary:hover { background: #d97706; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
</style>
